import React from "react";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";
import { MEAL_KEYS, MEAL_NAME } from "./format";
import { TMealKey } from "./types";

const cn = classNames.bind(styles);

interface IMealTicks {
  ticked: TMealKey[];
  orderable: TMealKey[];
  onToggle: (meal: TMealKey) => void;
}

/** One chip per meal. A meal the room cannot order is greyed out and cannot be ticked. */
const MealTicks: React.FC<IMealTicks> = ({ ticked, orderable, onToggle }) => (
  <div className={cn("chips")}>
    {MEAL_KEYS.map((m) =>
      orderable.indexOf(m) >= 0 ? (
        <label
          key={m}
          className={cn("chip", { chip_on: ticked.indexOf(m) >= 0 })}
        >
          <input
            type="checkbox"
            checked={ticked.indexOf(m) >= 0}
            onChange={() => onToggle(m)}
          />
          {MEAL_NAME[m]}
        </label>
      ) : (
        <span
          key={m}
          className={cn("chip", "chip_disabled")}
          title="Not available for this room"
        >
          {MEAL_NAME[m]}
          <small>Not available for this room</small>
        </span>
      )
    )}
  </div>
);

export default MealTicks;
